import { Check } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

export const PageHeader = ({ eyebrow, title, intro, testId }) => (
  <section className="relative overflow-hidden border-b border-border">
    <div className="pointer-events-none absolute inset-0 grid-bg opacity-50 [mask-image:radial-gradient(ellipse_at_top,black,transparent_75%)]" />
    <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
      {eyebrow && (
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h1 data-testid={testId} className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
          {title}
        </h1>
      </Reveal>
      {intro && (
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground">{intro}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export const Bullets = ({ items, testId }) => (
  <ul data-testid={testId} className="grid gap-3 sm:grid-cols-2">
    {items.map((t) => (
      <li key={t} className="flex items-start gap-3 rounded-lg border border-border bg-card p-4">
        <Check className="mt-0.5 h-4 w-4 shrink-0 text-foreground" />
        <span className="text-sm leading-relaxed text-muted-foreground">{t}</span>
      </li>
    ))}
  </ul>
);

export const Note = ({ children, testId }) => (
  <div data-testid={testId} className="mt-8 rounded-lg border border-border bg-secondary/60 p-5">
    <p className="text-sm leading-relaxed text-muted-foreground">{children}</p>
  </div>
);
